
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { useUrlValidation } from "@/hooks/useUrlValidation";

export const useUrlProcessor = (user: any) => {
  const navigate = useNavigate();
  const [isProcessingUrl, setIsProcessingUrl] = useState(false);
  const { validateUrl } = useUrlValidation();

  const processUrl = (url: string): boolean => {
    if (!user) {
      navigate('/auth');
      return false;
    }

    return validateUrl(url);
  };

  return {
    isProcessingUrl,
    setIsProcessingUrl,
    processUrl
  };
};
